import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-5" }
const _hoisted_2 = { class: "flex items-start gap-3" }
const _hoisted_3 = { class: "min-w-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium uppercase tracking-wide text-gray-500" }, "E-mail", -1)
const _hoisted_5 = {
  "data-testid": "doctor-contact-email",
  class: "text-base text-gray-900 break-words"
}
const _hoisted_6 = { class: "flex items-start gap-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium uppercase tracking-wide text-gray-500" }, "Telefone", -1)
const _hoisted_8 = {
  "data-testid": "doctor-contact-phone",
  class: "text-base text-gray-900"
}
const _hoisted_9 = {
  key: 0,
  class: "flex items-start gap-3"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium uppercase tracking-wide text-gray-500" }, "Localização", -1)
const _hoisted_11 = {
  "data-testid": "doctor-contact-location",
  class: "text-base text-gray-900"
}

import { computed } from 'vue'
import { mdiEmailOutline, mdiPhoneOutline, mdiMapMarkerOutline } from '@mdi/js'

import type { DoctorDetailResponse } from '@/Network/Types/Responses/CompanyResponses'
import DetailCard from '../atoms/DetailCard.vue'
import { formatPhone } from '@/utils/formatters'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactPanel',
  props: {
    doctor: {}
  },
  setup(__props: any) {

const props = __props;



const email = computed(() => props.doctor.doctor.user?.email || 'Não informado')
const phone = computed(() => {
  const raw = props.doctor.doctor.user?.mainPhone?.phoneNumber
  return raw ? formatPhone(raw) : 'Não informado'
})
const city = computed(() => props.doctor.doctor.user?.mainAddress?.city)
const uf = computed(() => props.doctor.doctor.user?.mainAddress?.state)

const location = computed(() => {
  if (city.value && uf.value) return `${city.value} - ${uf.value}`
  return city.value || uf.value || ''
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DetailCard, { title: "Contato" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_icon, {
            size: "20",
            color: "grey-darken-1",
            class: "mt-0.5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(mdiEmailOutline)), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("p", _hoisted_5, _toDisplayString(email.value), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_icon, {
            size: "20",
            color: "grey-darken-1",
            class: "mt-0.5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(mdiPhoneOutline)), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _hoisted_7,
            _createElementVNode("p", _hoisted_8, _toDisplayString(phone.value), 1)
          ])
        ]),
        (location.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_v_icon, {
                size: "20",
                color: "grey-darken-1",
                class: "mt-0.5"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(mdiMapMarkerOutline)), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", null, [
                _hoisted_10,
                _createElementVNode("p", _hoisted_11, _toDisplayString(location.value), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})